module.exports = __webpack_public_path__ + "static/media/frames_Q6A.ab6cd4f8.png";